module.exports = __webpack_public_path__ + "img/mollie-vector-logo.78735c18.svg";